module.exports = __webpack_public_path__ + "img/Hero.cda61769.png";